<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" outlined dense label="车牌号"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-select outlined dense v-model="queryForm.platform" label="平台" :items="['星星充电', '五牛新能源', '特来电', '云快充', '新电途']"
          clearable :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"></v-select>
      </v-col>
      <v-col cols="12" xl="1" lg="3" md="4" sm="6">
        <v-select outlined dense v-model="queryForm.match_state" label="状态" :items="[
          { text: '未匹配', value: 0 },
          { text: '已匹配', value: 1 },
        ]" clearable :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"></v-select>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <UploadTask btnText="上传充电记录" btnColor="cyan" modelTitle="上传充电记录" :Category="true"
            :alertText="`上传Excel文件需包含 <span class='error--text'>车牌号</span>、<span class='error--text'>开始时间</span>、<span>结束时间</span>、<span class='error--text'>充电时长</span>、<span class='error--text'>充电量</span>、<span>充电费</span>、<span class='error--text'>服务费</span>、<span>总额</span>、<span>充电桩地点</span> 字段。`"
            uploadType="vehiclerecharge" :templateFile="templateFile" />
          <v-btn color="success" dark tile @click="download">
            <v-icon small>mdi-download</v-icon> 下载充电数据
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="[summaryRow, ...list]" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="order_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="kwh" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh1" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh2" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh3" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh4" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh5" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="electric_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="service_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="total_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="price" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="optime" slot-scope="text, record">
          {{ record._isSummary ? '' : record.optime | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="match_state" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <v-btn v-if="record.match_state === 1" color="primary" text tile small @click="showmatchresult(record)">
              已匹配
            </v-btn>
            <span v-else>未匹配</span>
          </template>
        </template>
        <!-- <template slot="action" slot-scope="text, record">
          <a-space>
            <a-popconfirm title="删除充电记录" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template> -->
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="matchmodel" persistent max-width="600px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          匹配详情
          <v-icon @click="() => matchmodel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a-table size="small" :columns="matchheaders" :data-source="matchresult" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "Recharge",
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      queryForm: {
        start_day: "",
        end_day: "",
        vehicle_number: "",
        platform: "",
        match_state: "",
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "订单号", dataIndex: "order_number", scopedSlots: { customRender: "order_number" }, width: 150, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "状态", dataIndex: "match_state", scopedSlots: { customRender: "match_state" }, width: 120, align: "center" },
        { title: "开始时间", dataIndex: "start_time", scopedSlots: { customRender: "start_time" }, width: 120, align: "center" },
        { title: "结束时间", dataIndex: "end_time", scopedSlots: { customRender: "end_time" }, width: 120, align: "center" },//套牌号
        { title: "充电时长(分)", dataIndex: "duration", scopedSlots: { customRender: "duration" }, width: 120, align: "center" },
        { title: "充电量(度)", dataIndex: "kwh", scopedSlots: { customRender: "kwh" }, width: 120, align: "center" },
        { title: "尖时(度)", dataIndex: "kwh1", scopedSlots: { customRender: "kwh1" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "峰时(度)", dataIndex: "kwh2", scopedSlots: { customRender: "kwh2" }, width: 120, align: "center" },
        { title: "平时(度)", dataIndex: "kwh3", scopedSlots: { customRender: "kwh3" }, width: 180, align: "center" },
        { title: "谷时(度)", dataIndex: "kwh4", scopedSlots: { customRender: "kwh4" }, width: 120, align: "center" },
        { title: "深谷(度)", dataIndex: "kwh5", scopedSlots: { customRender: "kwh5" }, width: 120, align: "center" },
        { title: "充电费(元)", dataIndex: "electric_fee", scopedSlots: { customRender: "electric_fee" }, width: 120, align: "center" },
        { title: "服务费(元)", dataIndex: "service_fee", scopedSlots: { customRender: "service_fee" }, width: 120, align: "center" },
        { title: "总额(元)", dataIndex: "total_fee", scopedSlots: { customRender: "total_fee" }, width: 120, align: "center" },
        { title: "单价(元/度)", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
        { title: "地点", dataIndex: "location.address", scopedSlots: { customRender: "location.address" }, width: 120, align: "center" },
        { title: "平台", dataIndex: "platform", scopedSlots: { customRender: "platform" }, width: 120, align: "center" },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "optime" }, width: 180, align: "center" },
        // { title: "操作人", dataIndex: "opby", scopedSlots: { customRender: "opby" }, width: 120, align: "center" },
        // { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 100, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      templateFile: {
        url: `${process.env.BASE_URL}template/充电数据导入模板.xlsx`,
        name: '充电数据导入模板.xlsx',
      },
      matchmodel: false,
      matchheaders: [
        { title: "邮路", dataIndex: "postroute", scopedSlots: { customRender: "postroute" } },
        { title: "派车单号", dataIndex: "dispatch_no", scopedSlots: { customRender: "dispatch_no" } },
        { title: "里程", dataIndex: "mileage", scopedSlots: { customRender: "mileage" } },
        { title: "费用", dataIndex: "electricityrecharge_fee", scopedSlots: { customRender: "electricityrecharge_fee" } },
        { title: "电量(kWh)", dataIndex: "electricityrecharge_kwh", scopedSlots: { customRender: "electricityrecharge_kwh" } },
      ],
      matchresult: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryRow() {
      if (!this.list || this.list.length === 0) return { _id: 'summary', _isSummary: true, order_number: '合计' };
      const sum = (key) => this.list.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
      const avg = (key) => {
        const validRows = this.list.filter(row => Number(row[key]) > 0);
        if (!validRows.length) return 0;
        return sum(key) / validRows.length;
      };
      return {
        _id: 'summary',
        _isSummary: true,
        order_number: '合计',
        // vehicle_number: `${this.list.length}条`,
        kwh: Math.round(sum('kwh') * 100) / 100,
        kwh1: Math.round(sum('kwh1') * 100) / 100,
        kwh2: Math.round(sum('kwh2') * 100) / 100,
        kwh3: Math.round(sum('kwh3') * 100) / 100,
        kwh4: Math.round(sum('kwh4') * 100) / 100,
        kwh5: Math.round(sum('kwh5') * 100) / 100,
        electric_fee: Math.round(sum('electric_fee') * 100) / 100,
        service_fee: Math.round(sum('service_fee') * 100) / 100,
        total_fee: Math.round(sum('total_fee') * 100) / 100,
        price: (() => {
          const totalFee = Math.round(sum('total_fee') * 100) / 100;
          const totalKwh = Math.round(sum('kwh') * 100) / 100;
          return totalKwh ? (totalFee / totalKwh).toFixed(2) : '0.00';
        })(),
      };
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      start_day: start_day,
      end_day: end_day,
      vehicle_number: "",
      platform: "",
      match_state: "",
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/list", { page: this.page, limit: this.limit, ...this.queryForm, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },


    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showmatchresult(item) {
      this.matchresult = [
        ...(item.bills.length > 0 ? [
          {
            postroute: "合计",
            mileage: item.bills.reduce((a, b) => a.plus(b.mileage), this.$d()).toString(),
            electricityrecharge_fee: item.bills.reduce((a, b) => a.plus(b.electricityrecharge_fee), this.$d()).toString(),
            electricityrecharge_kwh: item.bills.reduce((a, b) => a.plus(b.electricityrecharge_kwh), this.$d()).toString(),
          }
        ] : []),
        ...item.bills,
      ];
      this.matchmodel = true;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
